export default __webpack_public_path__ + "static/media/clockonicon.b321a602.svg";